import { createFileRoute } from '@tanstack/react-router'
import { ParametrosPage } from '@/pages/parametros/ParametrosPage'

export const Route = createFileRoute('/_auth/parametros')({
  component: ParametrosPage,
})
